import type * as ecModels from '../../../models'
import * as plugin from '../../plugin'

import { getActionsConfig } from './actions'
import { Config } from './config'
import * as effects from './effects'
import * as extraReducers from './extra-reducers'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * TODO: documentation
 */
export class Plugin<
  TTypeParams extends ecModels.TypeParams.Constraint,
> extends plugin.Plugin<
  TTypeParams,
  plugin.Plugin.Id.Standard.Group,
  State<TTypeParams>,
  Selectors<TTypeParams>,
  ReturnType<typeof getActionsConfig<TTypeParams>>
> {
  /**
   * TODO:
   */
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly config

  constructor({ collection, config }: Plugin.constructor.Params<TTypeParams>) {
    const finalConfig = Config.from(config)
    super({
      actions: getActionsConfig(collection),
      collection,
      id: plugin.Plugin.Id.Standard.Group,
      initialState: State.getInitialState(finalConfig),
      selectors: () => new Selectors(this),
    })

    this.config = finalConfig
    this.feature.registerEffects(effects.getEntitiesForGroups(this))
    this.feature.registerExtraReducers(extraReducers.resetOnContextChange(this))
  }
}
export namespace Plugin {
  export namespace constructor {
    export type Params<TTypeParams extends ecModels.TypeParams.Constraint> =
      Pick<plugin.Plugin.Default<TTypeParams>, 'collection'> & {
        config?: Config.Options<TTypeParams>
      }
  }
}
